/* Carrinho seguro (Caio, 29/10/2026). Quando a cliente muda a quantidade ou clica em Remover, o tema pede a Shopify
   a parte do carrinho redesenhada junto com a mudanca (campo "sections"). As vezes a Shopify devolve essa parte vazia (null)
   e o tema trava: a peca sai, a tela nao atualiza e o 2o clique mostra "nenhum parametro de linha ou id valido".
   Aqui, se vier vazia, buscamos a parte do carrinho de novo e entregamos ao tema como se tivesse vindo junto.
   Outros scripts (estatisticas) tambem trocam o fetch depois de nos; por isso conferimos e reinstalamos por 30 s. */
(function () {
  function embrulha(base) {
    var novo = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = base.apply(this, arguments);
      if (!/\/cart\/(change|update|add)(\.js)?/.test(url) || !init || typeof init.body !== 'string') return p;
      var pedidas;
      try { pedidas = JSON.parse(init.body).sections; } catch (e) { return p; }
      if (!pedidas) return p;
      var lista = Array.isArray(pedidas) ? pedidas : String(pedidas).split(',');
      return p.then(function (resp) {
        if (!resp.ok) return resp;
        return resp.clone().json().then(function (j) {
          var falta = !j.sections || lista.some(function (s) { return j.sections[s] == null; });
          if (!falta) return resp;
          return base('/?sections=' + encodeURIComponent(lista.join(',')) + '&_mt=' + Date.now()).then(function (r) { return r.json(); }).then(function (secs) {
            j.sections = j.sections || {};
            lista.forEach(function (s) { if (j.sections[s] == null && secs[s] != null) j.sections[s] = secs[s]; });
            return new Response(JSON.stringify(j), { status: resp.status, statusText: resp.statusText, headers: resp.headers });
          });
        }).catch(function () { return resp; });
      });
    };
    novo.__mtSeguro = true;
    return novo;
  }
  function instala() { if (!window.fetch.__mtSeguro) window.fetch = embrulha(window.fetch); }
  instala();
  var n = 0, t = setInterval(function () { instala(); if (++n >= 30) clearInterval(t); }, 1000);
  window.addEventListener('load', instala);
})();
